import angular from 'angular';
import Logger from '../../../shared/logger';

export const CandidateApprovalService = (Restangular) => {
    const sendResumeToCandidate = function (data) {
        return Restangular
            .all('candidateApprove')
            .all('sendResumeToCandidate')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const approveSubmission = function (workflowId) {
        return Restangular.one('candidateApprove', workflowId)
            .all('approveResume')
            .get('')
            .catch(error => Logger.error(error));
    };

    const sendMessageToRecruiter = function (workflowId, data) {
        return Restangular.one('candidateApprove', workflowId)
            .all('sendMessageToRecruiter')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getPosition = function (workflowId) {
        return Restangular.one('candidateApprove', workflowId)
            .all('getPosition')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getResumeApprovalRequest = function (workflowId) {
        return Restangular.one('candidateApprove', workflowId)
            .all('requestApproval')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getCandidateApproveProfile = function (workflowId) {
        return Restangular.one('candidateApprove', workflowId)
            .all('profile')
            .get('')
            .catch(error => Logger.error(error));
    };

    return {
        sendResumeToCandidate,
        approveSubmission,
        sendMessageToRecruiter,
        getPosition,
        getCandidateApproveProfile,
        getResumeApprovalRequest,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CandidateApprovalService', CandidateApprovalService);
